import { render, staticRenderFns } from "./_TradeLaw.vue?vue&type=template&id=28828faf&scoped=true&"
import script from "./_TradeLaw.vue?vue&type=script&lang=js&"
export * from "./_TradeLaw.vue?vue&type=script&lang=js&"
import style0 from "./_TradeLaw.vue?vue&type=style&index=0&id=28828faf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28828faf",
  null
  
)

export default component.exports